var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({ref:"inputRef",attrs:{"value":_vm.formattedValue,"hide-details":"","outlined":"","dense":""}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }